import { GenericValue, DynamicContent } from 'hisng';
import { ResearchPartnerSimple, Address } from 'app/fs/res/common/model/researchPartner/researchPartner';

export class OrgunitSimple extends GenericValue {
    postAddresses?: Address[];
    emails?: Address[];
    phones?: Address[];
    hyperlinks?: Address[];
}

export class BudgetSource extends DynamicContent {
    id: number;
    uniquename: string;
    defaulttext: string;
    shorttext: string;
    longtext: string;
    parent: BudgetSource;
    budgetSourceType: GenericValue;
    budgetSourceCategory: GenericValue;
    purposeOfFunding: string;
    researchPartner: ResearchPartnerSimple;
    projectManagement: ResearchPartnerSimple;
    organization: OrgunitSimple;
    isSelectable: GenericValue;
    validFrom: string | Date;
    validTo: string | Date;
    status: GenericValue;
    kdsfCategory: GenericValue;

    constructor();
    constructor( id: number, uniquename: string, shorttext: string, defaulttext: string, longtext: string,
                 kdsfCategory: GenericValue );
    constructor( id?: number, uniquename?: string, shorttext?: string, defaulttext?: string, longtext?: string,
        kdsfCategory?: GenericValue ) {
        super();
        this.id = id;
        this.uniquename = uniquename;
        this.shorttext = shorttext;
        this.defaulttext = defaulttext;
        this.longtext = longtext;
        this.kdsfCategory = kdsfCategory;
    }
}
